import { Validators } from '@angular/forms';
import { ButtonType, CrudFormConfig, CrudFormTextBoxItem, CrudViewFormItemType, FormLayout, TextBoxType } from '@rappider/rappider-components/utils';

export const ConnectS3EditForm: CrudFormConfig = {
  items: [
    <CrudFormTextBoxItem>{
      title: 'Access Key',
      fieldName: 'accessKey',
      type: CrudViewFormItemType.TextBox,
      textType: TextBoxType.Password,
      showRequiredSign: true,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'Secret Access Key',
      fieldName: 'secretAccessKey',
      type: CrudViewFormItemType.TextBox,
      textType: TextBoxType.Password,
      showRequiredSign: true,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'Bucket Name',
      fieldName: 'bucketName',
      type: CrudViewFormItemType.TextBox,
      showRequiredSign: true,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'Region',
      fieldName: 'region',
      type: CrudViewFormItemType.TextBox
    }
  ],
  itemSettings: {
    inputComponentSize: {
      xs: 24
    },
    labelComponentSize: {
      xs: 24
    },
  },
  submitButton: {
    type: ButtonType.Primary
  },
  formLayout: FormLayout.Vertical
};

